import React, { useState, useCallback, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FiLogIn } from 'react-icons/fi'
import ReactTooltip from 'react-tooltip'

import { Navbar, MenuContainer } from './styles'

import logo from '~/assets/images/logo.png'

export default function () {
    const [menuOpen, setMenuOpen] = useState(false)

    const toggleMenu = useCallback(() => {
        const menu = document.querySelector('.menu')
        const items = [...menu.querySelectorAll('aside > *')]

        document.body.style.overflow = menuOpen ? 'initial' : 'hidden'

        menu.classList.toggle('on', !menuOpen)
        menu.classList.toggle('slideInLeft', !menuOpen)
            
        items.forEach((option, i) => {
            option.classList.add('animated', 'fadeInLeft', 'faster', `delay-${(i + 1) * 200}ms`)
        })

        setMenuOpen(!menuOpen)
    }, [menuOpen])

    useEffect(() => {
        if(menuOpen) {
            const options = document.querySelector('.menu aside')
            options.addEventListener('click', toggleMenu)
        }
    }, [menuOpen, toggleMenu])

    return (
        <>
            <Navbar>
                <img src={logo} alt="Home" />

                <MenuContainer className="menu animated faster">
                    <div className="menu-toggle" onClick={toggleMenu} role="button" tabIndex={0}>
                        <div className="one" />
                        <div className="two" />
                        <div className="three" />
                    </div>

                    <aside>
                        <a 
                            href="/codigo_etica" 
                            target="_blank" 
                            data-for="popup" 
                            data-html
                            data-tip={`<p style="font-weight: 700; font-size: 15px; margin-bottom: 10px">NOVIDADE!<p>
                                A nova Inteligência Artificial<br/>do SINDMEPA pode lhe ajudar<br/>respondendo qualquer coisa<br/>sobre o Código de Ética Médica.`}
                            className="flex items-end"
                        >
                            <span>Código de Ética</span>

                            <div className="bg-yellow-500 w-3 h-3 rounded-full animate-ping" />
                            <span className="bg-white/80 text-slate-800 text-xs rounded-md px-1 py-0.5 mt-3 -ml-2">Novo!</span>
                        </a>

                        <Link to="/evento/publico">
                            <span>Eventos</span>
                        </Link>

                        <Link to="/publicacao/publico">
                            <span>Acervo SINDMEPA</span>
                        </Link>

                        <Link to="/consulta_publica">
                            <span>Consulta de Associados</span>
                        </Link>

                        <Link to="/certificado">
                            <span>Verificação de certificados</span>
                        </Link>

                        <Link to="/atendimento">
                            <span>Denúncia</span>
                        </Link>

                        <Link to="/associacao">
                            <span>Associação</span>
                        </Link>

                        <Link to="/">
                            <FiLogIn size={20} style={{ marginRight: 6 }} />
                            <span>Login</span>
                        </Link>
                    </aside>
                </MenuContainer>
            </Navbar>

            <ReactTooltip 
                id="popup" 
                place="bottom"
                effect="solid"
                type="light"
                
            />
        </>
    )
}
